module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/reputacionIconDisabled.04644c46.svg";